import { Sparkles, Shirt, Shield, Users, Gift, FileImage } from "lucide-react";

export const PRODUCT_SUGGESTIONS = {
  birthday: {
    title: "Birthday Celebration",
    products: [
      { name: "Celebration T-Shirt", desc: "Custom vintage-style birthday tee", path: "/celebration-tshirts", icon: <Shirt className="w-4 h-4" /> },
      { name: "Happy Moments Card", desc: "3D digital birthday card with AI face-swap", path: "/happy-moments", icon: <Sparkles className="w-4 h-4" /> },
      { name: "Group Birthday Card", desc: "Collaborative card everyone can sign", path: "/group-cards", icon: <Users className="w-4 h-4" /> },
    ]
  },
  wedding: {
    title: "Wedding & Anniversary",
    products: [
      { name: "Family Coat of Arms", desc: "Unite two families with a custom crest", path: "/coat-of-arms", icon: <Shield className="w-4 h-4" /> },
      { name: "Anniversary T-Shirt", desc: "Commemorate the special year", path: "/celebration-tshirts", icon: <Shirt className="w-4 h-4" /> },
      { name: "Group Wedding Card", desc: "Guests sign a beautiful card together", path: "/group-cards", icon: <Users className="w-4 h-4" /> },
    ]
  },
  graduation: {
    title: "Graduation",
    products: [
      { name: "Class Year T-Shirt", desc: "Celebrate with a vintage graduation tee", path: "/celebration-tshirts", icon: <Shirt className="w-4 h-4" /> },
      { name: "Graduation Card", desc: "Digital card with memories", path: "/happy-moments", icon: <Sparkles className="w-4 h-4" /> },
    ]
  },
  party: {
    title: "Party & Events",
    products: [
      { name: "Wanted Poster", desc: "Fun Wild West style posters for parties", path: "/wanted-poster", icon: <FileImage className="w-4 h-4" /> },
      { name: "Event T-Shirts", desc: "Custom tees for your group", path: "/celebration-tshirts", icon: <Shirt className="w-4 h-4" /> },
      { name: "Group Card", desc: "Collect messages from everyone", path: "/group-cards", icon: <Users className="w-4 h-4" /> },
    ]
  },
  family: {
    title: "Family & Heritage",
    products: [
      { name: "Family Coat of Arms", desc: "Create your unique family crest", path: "/coat-of-arms", icon: <Shield className="w-4 h-4" /> },
      { name: "Time Capsule", desc: "Lock memories for future generations", path: "/time-capsule", icon: <Gift className="w-4 h-4" /> },
    ]
  },
  gift: {
    title: "Unique Gifts",
    products: [
      { name: "Custom T-Shirt", desc: "Personalized celebration apparel", path: "/celebration-tshirts", icon: <Shirt className="w-4 h-4" /> },
      { name: "Digital Card", desc: "3D immersive greeting card", path: "/happy-moments", icon: <Sparkles className="w-4 h-4" /> },
      { name: "Family Crest", desc: "A timeless heritage gift", path: "/coat-of-arms", icon: <Shield className="w-4 h-4" /> },
    ]
  }
};

export const QUICK_OPTIONS = [
  { label: "🎂 Birthday", key: "birthday" },
  { label: "💒 Wedding", key: "wedding" },
  { label: "🎓 Graduation", key: "graduation" },
  { label: "🎉 Party", key: "party" },
  { label: "👨‍👩‍👧‍👦 Family", key: "family" },
  { label: "🎁 Gift Ideas", key: "gift" },
];

// Map free text to a suggestion category
export const analyzeInput = (text) => {
  const lower = text.toLowerCase();
  if (lower.includes("birthday") || lower.includes("born") || lower.includes("age")) return "birthday";
  if (lower.includes("wedding") || lower.includes("married") || lower.includes("anniversary") || lower.includes("engaged")) return "wedding";
  if (lower.includes("graduat") || lower.includes("school") || lower.includes("class of") || lower.includes("university")) return "graduation";
  if (lower.includes("party") || lower.includes("event") || lower.includes("stag") || lower.includes("hen") || lower.includes("bachelor")) return "party";
  if (lower.includes("family") || lower.includes("heritage") || lower.includes("crest") || lower.includes("coat of arms") || lower.includes("legacy")) return "family";
  if (lower.includes("gift") || lower.includes("present") || lower.includes("surprise")) return "gift";
  if (lower.includes("t-shirt") || lower.includes("tshirt") || lower.includes("shirt") || lower.includes("apparel")) return "birthday";
  if (lower.includes("card") || lower.includes("sign") || lower.includes("message")) return "party";
  if (lower.includes("poster") || lower.includes("wanted") || lower.includes("western") || lower.includes("cowboy")) return "party";
  return null;
};
